import * as React from 'react';
import { useContext } from 'react';

import type { SkillPathway_PartnerFragment as Partner } from 'bundles/enterprise-learning-path-description-page/queries/__generated__/GetPartnersByIds';

type SkillPathwayPartnersContextType =
  | {
      partners?: Partner[] | null;
    }
  | undefined;

const SkillPathwayPartnersContext = React.createContext<SkillPathwayPartnersContextType>(undefined);

export const useSkillPathwayPartners = () => {
  const context = useContext(SkillPathwayPartnersContext);
  return context?.partners;
};

export default SkillPathwayPartnersContext;
